var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7 42.25C12.2333 40.65 9.41667 38.2333 7.25 35C5.08333 31.7667 4 28.1167 4 24.05C4 23.1833 4.04167 22.3333 4.125 21.5C4.20833 20.6667 4.35 19.85 4.55 19.05L2.25 20.4L0.25 16.95L9.8 11.45L15.3 20.95L11.8 22.95L9.1 18.25C8.73333 19.15 8.45833 20.0833 8.275 21.05C8.09167 22.0167 8 23.0167 8 24.05C8 27.2833 8.88333 30.225 10.65 32.875C12.4167 35.525 14.7667 37.4833 17.7 38.75L15.7 42.25ZM31 18V14H36.45C34.9167 12.1 33.0667 10.625 30.9 9.575C28.7333 8.525 26.4333 8 24 8C22.1667 8 20.4333 8.28333 18.8 8.85C17.1667 9.41667 15.6667 10.2167 14.3 11.25L12.3 7.75C13.9667 6.58333 15.7833 5.66667 17.75 5C19.7167 4.33333 21.8 4 24 4C26.6333 4 29.15 4.49167 31.55 5.475C33.95 6.45833 36.1 7.88333 38 9.75V7H42V18H31ZM29.7 48L20.15 42.5L25.65 33L29.1 35L26.25 39.9C30.1833 39.3333 33.4583 37.55 36.075 34.55C38.6917 31.55 40 28.0333 40 24C40 23.6333 39.9917 23.2917 39.975 22.975C39.9583 22.6583 39.9167 22.3333 39.85 22H43.9C43.9333 22.3333 43.9583 22.6583 43.975 22.975C43.9917 23.2917 44 23.6333 44 24C44 28.5 42.6583 32.525 39.975 36.075C37.2917 39.625 33.8 42.0167 29.5 43.25L31.7 44.55L29.7 48Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/updated.1de4c889b9d04afc5147a0ddc9eb9f0a.svg";
export { ForwardRef as ReactComponent };